import { createRootRoute, Outlet, useRouterState } from "@tanstack/react-router"
import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { MantineProvider, localStorageColorSchemeManager } from "@mantine/core"
import { Notifications } from "@mantine/notifications"
import { Header } from "@/components/layout/Header"
import { Footer } from "@/components/layout/Footer"
import { TransparencyBanner } from "@/components/ui/TransparencyBanner"
import { theme } from "@/lib/mantine-theme"
import { lazy, Suspense, useEffect } from "react"

const TanStackRouterDevtools = lazy(() =>
  import("@tanstack/react-router-devtools").then((d) => ({
    default: d.TanStackRouterDevtools,
  })),
)

export const Route = createRootRoute({
  component: RootComponent,
})

const colorSchemeManager = localStorageColorSchemeManager({
  key: "rtefn-color-scheme",
})

function RootComponent() {
  const routerState = useRouterState()

  // Scroll to top on route changes
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [routerState.location.pathname])

  return (
    <MantineProvider theme={theme} colorSchemeManager={colorSchemeManager} defaultColorScheme="light">
      <Notifications />
      <TransparencyBanner />
      <div className="min-h-screen flex flex-col">
        <Header />
        <main className="flex-1">
          <div key={routerState.location.pathname} className="page-transition">
            <Outlet />
          </div>
        </main>
        <Footer />
      </div>
      {import.meta.env.DEV && (
        <Suspense>
          <TanStackRouterDevtools />
          <ReactQueryDevtools />
        </Suspense>
      )}
    </MantineProvider>
  )
}
